import { useState } from 'react'
import ReactDOM from 'react-dom'
import moment from 'moment'

export function useTimePickerState(time, setTime, onError) {
    let [isOnError, setIsOnError] = useState<boolean>(!!onError)

    function onChange(newTime: moment.Moment | null) {
        let newState = {
            time: null as string | null,
            isOnError: false
        }

        if (newTime !== null) {
            if (!newTime.isValid()) {
                newState.isOnError = true
            } else {
                newState.time = moment(newTime).format('YYYY-MM-DDTHH:mm:ss')
            }
        }

        ReactDOM.unstable_batchedUpdates(() => {
            setTime(newState.time ?? time)
            setIsOnError(newState.isOnError)
        })
    }

    return { isOnError, setIsOnError, onChange }
}
